<div class="container-fluid mt-4">
<div class="row">

  <div class="col-lg-12">
    <div class="card">
      <div class=" card-header d-flex justify-content-between align-items-center">
        <h5 class="election-title">👩‍💼 Society Auditor Appoint  List</h5>


      </div>

      <!--end Modal -->
      <div class="card-body">
        <div class="row">


          <!-- Auditor NAme -->
          <div class="col-lg-3 col-md-6 mb-2">
            <label for="auditorname" class="form-label">Auditor</label>

            <input class="form-control" [(ngModel)]="filter.auditorname" (keyup)="search()"
              placeholder="Enter Any auditorname" id="auditorname" />
          </div>

          <!-- Keyword Filter -->
          <div class="col-lg-3 col-md-6 mb-2">
            <label for="keyword" class="form-label">Any Keywords</label>
            <input class="form-control" [(ngModel)]="filter.keyword" (keyup)="search()" placeholder="Enter Any Keywords"
              id="keyword" />
          </div>

          <!-- Search Button -->
          <div class="col-lg-12 mb-3 text-end">
            <button type="button" class="btn btn-primary btn-sm" title="Search" (click)="search()">
              <i class="bi bi-search"></i> Search
            </button>
          </div>

          <div class="col-lg-12">
            <div class="pagination-controls"
              style="display: flex; justify-content: flex-end; align-items: center; width: 100%;">
              <div class="pagination-right" style="display: flex; align-items: center;">
                <label for="rowsPerPage" style="margin-right: 8px;">Display Data:</label>
                <select id="rowsPerPage" [(ngModel)]="page.pageSize" (change)="onRowsPerPageChange()"
                  style="padding: 5px; font-size: 14px;">

                  <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{size}}</option>
                </select>
              </div>
            </div>
            <br />



            <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
              [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
              [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
              (page)="setPage($event)" [loadingIndicator]="loading">
              <!-- S.No. Column -->
              <ngx-datatable-column name="#" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                  <span>{{(page.pageNumber-0)*page.pageSize+rowIndex+1}}</span>
                </ng-template>
              </ngx-datatable-column>


              <!-- Dynamic Columns -->
              <ngx-datatable-column *ngFor="let column of columns" [sortable]="true" [name]="column.name"
                [prop]="column.prop">
                <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Action Column -->
              <!-- <ngx-datatable-column name="Action" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                 <button type="button" title="Audit Status & History" class="btn btn-info btn-sm"
                    style="margin-bottom: 10px;" (click)="auditStatus(row.iSocietyDetailsID,row.iAllotAuditorID)"
                    data-bs-toggle="modal" data-bs-target="#AuditorStatus">
                    <i class="bi bi-clock-history"></i> Audit Status
                  </button> 


                </ng-template>
              </ngx-datatable-column> -->

            </ngx-datatable>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>
</div>